module.exports = __webpack_public_path__ + "static/media/affordable-catering-3.e7ae0b41.jpg";